export enum AgentStatuses {
  ACTIVE = 'active',
  DISABLED = 'disabled',
  PENDING = 'pending',
  DELETED = 'deleted'
}
